
import GwError from '~/patterns/molecules/error';
import GwContentTemplate from '~/patterns/templates/content';
import FlexibleSection from '~/patterns/organisms/_flexible-section/flexible-section';

import GwPageContainer from '~/patterns/molecules/page-container/page-container.vue';
import GwPageTitle from '~/patterns/molecules/page-title/page-title.vue';

import getEditionsPage from '~/graphql/queries/getEditionsPage.graphql';
import seo from '~/mixins/seo';

export default {
    components: {
        GwPageContainer,
        GwPageTitle,
        GwError,
        GwContentTemplate,
        FlexibleSection,
    },
    mixins: [seo],
    layout: 'overview',
    data() {
        return {
            entry: null,
            notFound: false
        };
    },
    async fetch() {
        const site = this.$config.appMultisiteHandle,
            uri = this.$route.path.replace(/^\/|\/$/, ''),
            { data } = await this.$gql.executeQuery(
                getEditionsPage,
                { site, uri }
            );

        if (data && data.entry) {
            this.entry = data.entry;
        } else {
            this.notFound = true;
            if (process.server) {
                this.$nuxt.context.res.statusCode = 404;
            }
        }
    },
};
